export default __webpack_public_path__ + "static/media/float-full.928ea0b8.svg";